module.exports = __webpack_public_path__ + "img/Hoenn.0854ea98.png";